module.exports = __webpack_public_path__ + "img/lineup19@2x.db9cd2ce.png";